import React, { useState, useEffect } from 'react';
import useFadeIn from '../hooks/useFadeIn';

const painPoints = [
  'Manual Formulary Checks',
  'Coverage Confusions',
  'Prescription Delays',
  'Endless Phone Calls',
];

function PainPointsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const [ref, isVisible] = useFadeIn();

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % painPoints.length);
        setVisible(true);
      }, 400);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-[#f5f5f7] px-8 md:px-16 py-16 md:py-24">
      <div
        ref={ref}
        className={`fade-in-section ${isVisible ? 'is-visible' : ''} max-w-[1440px] mx-auto flex flex-col items-center text-center gap-5`}
      >

        <p className="text-lg md:text-xl text-[#6e6e73] max-w-xl leading-relaxed font-normal">
          Healthcare providers face daily challenges navigating complex prescription coverage.
        </p>

        <div className="mt-3 flex flex-col items-center gap-3">
          <h2 className="text-4xl md:text-5xl xl:text-[56px] text-[#1d1d1f] leading-tight">
            Say Goodbye to
          </h2>

          <div className="overflow-hidden" style={{ height: '80px' }}>
            <p
              className="text-4xl md:text-5xl xl:text-[56px] leading-tight font-semibold gradient-text"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(24px)',
                transition: 'opacity 0.5s cubic-bezier(0.16, 1, 0.3, 1), transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
              }}
            >
              {painPoints[currentIndex]}
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center gap-4 max-w-xl">
          <div className="h-px w-20 bg-[#d2d2d7]" />
          <p className="text-sm md:text-[15px] text-[#6e6e73] leading-relaxed font-normal">
            MedHug brings those answers together before the prescription leaves the visit.
          </p>
        </div>

      </div>
    </section>
  );
}

export default PainPointsSection;
